import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../Assets/Website Logo 1.png';
const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-main">
        <div className="footer-brand">
        
           <img src={logo} alt="Homeeera Logo" className="footer-logo" />
          
          <div className="footer-tagline">
            <span>Build</span><br />
            <span>Dreams</span><br />
            <span>Together<span className="footer-dot">.</span></span>
          </div>
        </div>
        <div className="footer-links">
          <div className="footer-col">
            <div className="footer-col-title">Company</div>
            <Link to={{ pathname: "/", state: { scrollTo: "vision" } }}>Our Vision</Link>
            <Link to="/connect">Connect Us</Link>
          </div>
          <div className="footer-col">
            <div className="footer-col-title">Platforms</div>
            <Link to={{ pathname: "/homeegram", state: { scrollTo: "platforms" } }}>Homeegram</Link>
            <Link >Homeeframes</Link>
            <Link >Homeeshare</Link>
          </div>
          <div className="footer-col">
            <div className="footer-col-title">Corporate Office</div>
            <div className="footer-address">
              NH 544, First Floor,<br />
              G.I Square, Above Lenskart,<br />
              Kothakulangara, Angamaly,<br />
              Kerala, India
            </div>
          </div>
        </div>
      </div>
      <hr className="footer-divider" />
      <div className="footer-bottom">
        <div className="footer-socials">
          {/* Social Media Icons */}
          <span className="footer-social-icon">✗</span>
          <span className="footer-social-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
            </svg>
          </span>
          <span className="footer-social-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
            </svg>
          </span>
          <span className="footer-social-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
              <rect width="4" height="12" x="2" y="9"></rect>
              <circle cx="4" cy="4" r="2"></circle>
            </svg>
          </span>
          <span className="footer-social-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"></path>
              <path d="m10 15 5-3-5-3z"></path>
            </svg>
          </span>
        </div>
        <div className="footer-copyright">
          All Right Reserved to Homeeera Platforms Pvt. Ltd
        </div>
      </div>
    </footer>
  );
};

export default Footer;